//Days
const subDays = require('date-fns/subDays')

//Weeks
const subWeeks = require('date-fns/subWeeks')
const startOfWeek = require('date-fns/startOfWeek')
const endOfWeek = require('date-fns/endOfWeek')

//Months
const subMonths = require('date-fns/subMonths')
const startOfMonth = require('date-fns/startOfMonth')
const endOfMonth = require('date-fns/endOfMonth')

//Quarters
const subQuarters = require('date-fns/subQuarters')
const startOfQuarter = require('date-fns/startOfQuarter')
const endOfQuarter = require('date-fns/endOfQuarter')

//Years
const subYears = require('date-fns/subYears')
const startOfYear = require('date-fns/startOfYear')
const endOfYear = require('date-fns/endOfYear')

//Format
const formatDate = require('date-fns/format')
const dateStringFormat = 'yyyy-MM-dd'

const leftPad = require('left-pad')

const ranges = [
	'Today',
	'Yesterday',
	'Last 7 Days',
	'Last 30 Days',
	'Last 90 Days',
	'Last 365 Days',
	'This Week',
	'This Month',
	'This Quarter',
	'This Year',
	'Previous Week',
	'Previous Month',
	'Previous Quarter',
	'Previous Year',
	'Custom',
]

const defaultRange = 'Last 90 Days'

function rangeFromDates(from, to) {
	const matchingRange = ranges.map(rangeName => {
		return { name: rangeName, ...datesFromRange(rangeName) }
	}).find(range => range.from === from && range.to === to)

	if (matchingRange) {
		return matchingRange.name
	}
	return 'Custom'
}

function datesFromRange(rangeName, formatValues = true) {
	const today = new Date()
	let range = {
		to: '',
		from: '',
	}

	switch (rangeName) {
		case 'Always':
			//same as default
			break
		case 'Today':
			range.from = today
			range.to = today
			break
		case 'Yesterday': {
			const yesterday = subDays(today, 1)
			range.from = yesterday
			range.to = yesterday
			break
		}
		case 'Last 7 Days':
			range.from = subWeeks(today, 1)
			range.to = today
			break
		case 'Last 30 Days':
			range.from = subDays(today, 30)
			range.to = today
			break
		case 'Last 90 Days':
			range.from = subDays(today, 90)
			range.to = today
			break
		case 'Last 365 Days':
			range.from = subDays(today, 365)
			range.to = today
			break
		case 'This Week':
			range.from = startOfWeek(today)
			range.to = endOfWeek(today)
			break
		case 'This Month':
			range.from = startOfMonth(today)
			range.to = endOfMonth(today)
			break
		case 'This Quarter':
			range.from = startOfQuarter(today)
			range.to = endOfQuarter(today)
			break
		case 'This Year':
			range.from = startOfYear(today)
			range.to = endOfYear(today)
			break
		case 'Previous Week': {
			const weekAgo = subWeeks(today, 1)
			range.from = startOfWeek(weekAgo)
			range.to = endOfWeek(weekAgo)
			break
		}
		case 'Previous Month': {
			const monthAgo = subMonths(today, 1)
			range.from = startOfMonth(monthAgo)
			range.to = endOfMonth(monthAgo)
			break
		}
		case 'Previous Quarter': {
			const quarterAgo = subQuarters(today, 1)
			range.from = startOfQuarter(quarterAgo)
			range.to = endOfQuarter(quarterAgo)
			break
		}
		case 'Previous Year': {
			const yearAgo = subYears(today, 1)
			range.from = startOfYear(yearAgo)
			range.to = endOfYear(yearAgo)
			break
		}
		case 'Custom':
			return undefined
	}

	if (formatValues) {
		range.from = formatDate(range.from, dateStringFormat)
		range.to = formatDate(range.to, dateStringFormat)
	}

	return range
}

// assumes input is UTC
function sqlToLocalDT(sqlDateString) {
	const offset = new Date().getTimezoneOffset() * 60 * 1000
	//const localMs = new Date(new Date(sqlDateString).getTime() - offset).getTime()
	const localDate = new Date(new Date(sqlDateString).getTime() - offset)
	return { date: localDate.toLocaleDateString(), time: localDate.toLocaleTimeString() }
}

/**
 * the z forces it to convert, even with toDateString, still converts
 */
function sqlToDT(sqlDateString) {
	const localDate = new Date(sqlDateString.replace('Z', ''))
	return { date: localDate.toLocaleDateString(), time: localDate.toLocaleTimeString() }
}

/**
 * get date in milliseconds but in localTime
 */
function localDateMs(time = Date.now()) {
	const offset = new Date().getTimezoneOffset() * 60 * 1000
	const inputTimeMs = new Date(time).getTime() // in utc
	return inputTimeMs - offset
}

function makeCurrentLocalDateTime() {
	let now = new Date()
	return { date: now.toDateString(), time: now.toTimeString(), ms: localDateMs() }
}

function getCurrentDateString() {
	return formatDate(new Date(), dateStringFormat)
}

function toLocaleDateString(dateString) {
	if (dateString === null || dateString === undefined) {
		return ''
	}
	//otherwise, toLocaleDateString will return the start of unix time
	dateString = dateString.length === 10 ? `${ dateString }T23:59:59Z` : dateString//mad hax bro
	return new Date(dateString).toLocaleDateString()
}

function getFourDigitDateFromTwo(givenYear, yearsOutThreshold = 2) {
	let yearString = givenYear.toString()

	if (yearString.length < 3) {
		//The value might be coming from a input, which means it may be a
		//number type so pad it with zeros in case they type 01, for example
		yearString = leftPad(yearString, 2, 0)
		const currentYearLastTwo = Number(formatDate(new Date(), 'yyyy').substring(2, 4))

		if (yearString > (currentYearLastTwo + yearsOutThreshold)) {
			return `19${ yearString }`
		}
		return `20${ yearString }`
	}
	return givenYear
}

function getYearArray() {
	const maxYear = Number(formatDate(new Date(), 'yyyy')) + 2
	let yearList = []

	for (var i = 1920; i <= maxYear; i++) {
		yearList.push(i)
	}

	return yearList
}

function dateToSQLDateTime(date = new Date()) {
	return formatDate(date, `yyyy-MM-dd HH:mm:ss`)
}

module.exports = {
	ranges,
	defaultRange,
	datesFromRange,
	rangeFromDates,
	sqlToLocalDT,
	sqlToDT,
	localDateMs,
	makeCurrentLocalDateTime,
	getCurrentDateString,
	toLocaleDateString,
	getFourDigitDateFromTwo,
	getYearArray,
	dateToSQLDateTime,
}
